import type { DeepRequired } from '../fixtures.types'

const kbaQuestion: DeepRequired<KbaQuestion> = {
  __typename: 'KbaQuestion',
  choices: [],
  id: 'TEST_ID',
  header: null,
  text: null,
}

export default kbaQuestion
